import {CL_RX_METHOD, PRESCRIPTION_STATUS, VISTA_PLUS} from 'constants/success';
import {OrderDetailsItemsType} from 'types/orderDetailsTypes';
import {SEND_LATER, FILL_IT, UPLOAD} from 'types/successPage';

import {getButtonText} from '../helpers/helpers';

const isEyeExam = (status: string) =>
    status === PRESCRIPTION_STATUS.EYE_EXAM || status === PRESCRIPTION_STATUS.VISIBLY;

type GetPopupType = {
    prescriptionType: number;
    prescriptionStatus: string;
    item: OrderDetailsItemsType;
    status: string;
    isVista: boolean;
};

const shouldShowPopup = ({
    isVista,
    item,
    prescriptionStatus,
    prescriptionType,
    status,
}: GetPopupType) =>
    item.prescription?.send_by === prescriptionType &&
    status !== prescriptionStatus &&
    !isEyeExam(status) &&
    !isVista;

const getVistaPrescriptionStatus = (status: string, item: OrderDetailsItemsType) => {
    if (
        status !== PRESCRIPTION_STATUS.FILL_SUCCESS &&
        item.prescription?.send_by !== UPLOAD &&
        !isEyeExam(status)
    ) {
        return PRESCRIPTION_STATUS.VISTA;
    }
    return PRESCRIPTION_STATUS.DEFAULT;
};

/**
 * Returns the type of popup
 */
export const getPopupType = (item: OrderDetailsItemsType | null, status: string) => {
    if (!item) return PRESCRIPTION_STATUS.DEFAULT;
    const isVista = item.product.brand.name === VISTA_PLUS;

    switch (true) {
        case shouldShowPopup({
            isVista,
            item,
            prescriptionStatus: PRESCRIPTION_STATUS.UPLOAD_SUCCESS,
            prescriptionType: SEND_LATER,
            status,
        }):
            return PRESCRIPTION_STATUS.UPLOAD_SUCCESS;

        case shouldShowPopup({
            isVista,
            item,
            prescriptionStatus: PRESCRIPTION_STATUS.FILL_SUCCESS,
            prescriptionType: FILL_IT,
            status,
        }) &&
            shouldShowPopup({
                isVista,
                item,
                prescriptionStatus: PRESCRIPTION_STATUS.UPLOAD_SUCCESS,
                prescriptionType: FILL_IT,
                status,
            }):
            return PRESCRIPTION_STATUS.FILL_SUCCESS;

        case isVista:
            return getVistaPrescriptionStatus(status, item);
        default:
            return PRESCRIPTION_STATUS.DEFAULT;
    }
};

/**
 * Gets the title for the popup
 */
export const getTitle = (rxMethod: string, popupType: string) => {
    switch (rxMethod) {
        case CL_RX_METHOD.EYE_EXAM:
        case CL_RX_METHOD.EYE_EXAM_ELIGIBILITY:
        case CL_RX_METHOD.EYE_EXAM_ELIGIBILITY_FAILED:
            return 'Prescription Renewal';
        case CL_RX_METHOD.DOCTOR:
        case CL_RX_METHOD.MANUALLY_DOCTOR:
            return 'Add Doctor Details';
        default:
            return getButtonText(popupType) || '';
    }
};
